import { render } from "./capturePhoto.vue?vue&type=template&id=49e6edb5&scoped=true&ts=true"
import script from "./capturePhoto.vue?vue&type=script&lang=ts"
export * from "./capturePhoto.vue?vue&type=script&lang=ts"

import "./capturePhoto.vue?vue&type=style&index=0&id=49e6edb5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e6edb5"]])

export default __exports__